import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';

const HomeServizi = () => {
  const navigate = useNavigate();

  const cities = [
  { name: 'Macerata', route: '/main-storefronts' }];


  return (
    <>
      <Helmet>
        <title>Cliccami.net - Commercio, Food e Servizi del territorio</title>
        <meta
          name="description"
          content="Scegli cosa vuoi fare oggi su Cliccami: scopri vetrine locali, ordina food dal territorio, accedi a servizi e informazioni utili." />
        
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header onFilterClick={() => {}} />

        {/* Linea divisoria sottile */}
        <div className="w-full border-t border-gray-300"></div>

        {/* 3️⃣ SEZIONE VETRINE - Griglia 2 colonne */}
        <section className="py-16 md:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
              {/* Colonna sinistra - Immagine (60%) */}
              <div className="lg:col-span-3">
                <img
                  src="/assets/images/Screenshot_2026-01-29_alle_16.33.06-1769700823092.png"
                  alt="Vetrine - Negozi locali"
                  className="w-full h-auto rounded-lg shadow-xl" />
                
              </div>
              
              {/* Colonna destra - Contenuti (40%) */}
              <div className="lg:col-span-2 space-y-6">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                  Torna spesso nei negozi della tua città
                </h2>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Novità, offerte e proposte sempre aggiornate dalle attività locali. Il tuo punto di riferimento quotidiano per scoprire cosa succede nella tua città.
                </p>
                
                {/* Card città */}
                <div className="mt-8">
                  {cities?.map((city) =>
                  <button
                    key={city?.name}
                    onClick={() => navigate(city?.route)}
                    className="w-full bg-white border border-gray-200 rounded-2xl px-5 py-5 flex items-center justify-between shadow-sm hover:shadow-md transition-all duration-300">
                    
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                          <Icon name="MapPin" size={24} className="text-primary" />
                        </div>
                        <div className="text-left">
                          <h3 className="text-xl font-bold text-foreground">{city?.name}</h3>
                          <p className="text-sm text-muted-foreground">Scopri le vetrine</p>
                        </div>
                      </div>
                      <Icon name="ChevronRight" size={24} className="text-muted-foreground" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 4️⃣ SEZIONE FOOD - Griglia 2 colonne invertita */}
        <section className="py-16 md:py-24 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
              {/* Colonna sinistra - Contenuti */}
              <div className="lg:col-span-2 space-y-6 order-2 lg:order-1">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                  Dal locale alla tua tavola
                </h2>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Ordina dai ristoranti e dalle attività food del tuo territorio, senza passaggi inutili. Cucina locale e consegna di prossimità, direttamente a casa tua.
                </p>
                <button
                  onClick={() => navigate('/food')}
                  className="bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-4 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105 inline-block mt-4">
                  
                  Vai al Food
                </button>
              </div>
              
              {/* Colonna destra - Immagine */}
              <div className="lg:col-span-3 order-1 lg:order-2">
                <img
                  src="/assets/images/Consegna-1769702899867.png"
                  alt="Food - Delivery locale"
                  className="w-full h-auto rounded-lg shadow-xl" />
                
              </div>
            </div>
          </div>
        </section>

        {/* 4.5️⃣ SEZIONE FARMACIA - Griglia 2 colonne invertita */}
        <section className="py-16 md:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
              {/* Colonna sinistra - Contenuti */}
              <div className="lg:col-span-2 space-y-6 order-2 lg:order-1">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                  Dalla farmacia a casa tua
                </h2>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Invia la ricetta alla farmacia del tuo territorio e ricevi i farmaci a domicilio. Servizi sanitari locali, semplici e veloci.
                </p>
                <button
                  onClick={() => navigate('/farma-service-city')}
                  className="bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-4 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105 inline-block mt-4">
                  
                  Vai alla Salute
                </button>
              </div>
              
              {/* Colonna destra - Immagine */}
              <div className="lg:col-span-3 order-1 lg:order-2">
                <img
                  src="/assets/images/FarmaciaHome-1771148543553.jpeg"
                  alt="Farmacia - Servizi sanitari a domicilio"
                  className="w-full h-auto rounded-lg shadow-xl" />
                
              </div>
            </div>
          </div>
        </section>

        {/* 4.6️⃣ SEZIONE UNIDAYMC - Griglia 2 colonne */}
        <section className="py-16 md:py-24 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
              {/* Colonna sinistra - Immagine */}
              <div className="lg:col-span-3">
                <div className="w-full h-auto rounded-lg shadow-xl bg-white p-8 flex items-center justify-center">
                  <img
                    src="/assets/images/LogoUnidaySmall-1771236317519.jpg"
                    alt="UniDayMc - Logo con cappello e scritta UNIDAY MOVE TO MACERATA"
                    className="w-full md:w-auto h-auto object-contain"
                    style={{ maxWidth: '480px', maxHeight: '400px' }} />
                </div>
              </div>
              
              {/* Colonna destra - Contenuti */}
              <div className="lg:col-span-2 space-y-6">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                  UniDayMc
                </h2>
                <p className="text-xl text-gray-600 font-medium">
                  Il mondo universitario a portata di clic
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Offerte, servizi e iniziative per studenti e docenti a Macerata. Scopri convenzioni, eventi e opportunità dedicate.
                </p>
                
                {/* Bottone UniDayMc */}
                <div className="mt-4">
                  <a
                    href="https://unidaymc-s0scs01.public.builtwithrocket.new"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-4 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105">
                    Scopri UniDayMc
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 5️⃣ SEZIONE SERVIZI - Griglia 2 colonne */}
        <section className="py-16 md:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
              {/* Colonna sinistra - Immagine */}
              <div className="lg:col-span-3">
                <img
                  src="/assets/images/IconaStampa-1769768462437.png"
                  alt="Donna che legge il giornale - Notizie locali"
                  className="w-full h-auto rounded-lg shadow-xl" />
                
              </div>
              
              {/* Colonna destra - Contenuti */}
              <div className="lg:col-span-2 space-y-6">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
Le notizie della città, ogni giorno
                </h2>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Consulta ogni giorno le notizie dal territorio, accedendo direttamente alle principali testate giornalistiche.Il punto di partenza quotidiano per essere sempre informato su ciò che accade in città.
                </p>
                
                {/* Bottone Rassegna Stampa */}
                <div className="mt-4">
                  <button
                    onClick={() => navigate('/rassegna-stampa')}
                    className="bg-purple-600 hover:bg-purple-700 text-white font-semibold px-8 py-4 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105">
                    
                    Entra in Edicola
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 6️⃣ SEZIONE RICARICHE TELEFONICHE - Griglia 2 colonne invertita */}
        <section className="py-16 md:py-24 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
              {/* Colonna sinistra - Contenuti */}
              <div className="lg:col-span-2 space-y-6 order-2 lg:order-1">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                  Ricariche Telefoniche
                </h2>
                <p className="text-xl text-gray-600 font-medium">
                  Ricarica il tuo numero in pochi secondi
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Accedi rapidamente alle principali compagnie telefoniche e ricarica online in modo semplice, sicuro e diretto. Un servizio veloce pensato per chi vuole tutto a portata di clic.
                </p>
                
                {/* Bottone Ricariche */}
                <div className="mt-4">
                  <button
                    onClick={() => navigate('/ricariche-telefoniche')}
                    className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold px-8 py-4 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl">
                    
                    Vai alle Ricariche
                  </button>
                </div>
              </div>
              
              {/* Colonna destra - Immagine */}
              <div className="lg:col-span-3 order-1 lg:order-2">
                <img
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_1f564f330-1767147652733.png"
                  alt="Ricariche telefoniche - Servizio rapido e sicuro"
                  className="w-full h-auto object-cover rounded-lg shadow-xl"
                  style={{ aspectRatio: '16/6' }}
                  loading="lazy"
                  decoding="async" />
                
              </div>
            </div>
          </div>
        </section>
      </div>
    </>);

};

export default HomeServizi;